import axios from "axios"
import {
     CONST_API_PERSONNEL_DECLARATION_GET_NDF_BY_ID_ENDPOINT,
     CONST_API_PERSONNEL_DECLARATION_GET_NDF_DEPENSES_ENDPOINT,
     CONST_API_PERSONNEL_DECLARATION_NDF_ADD_DEPENSE_GROUPED_ENDPOINT,
     CONST_API_PERSONNEL_DECLARATION_NDF_ADD_DEPENSE_SIMPLE_ENDPOINT,
     CONST_API_PERSONNEL_DECLARATION_NDF_DELETE_ENDPOINT,
     CONST_API_PERSONNEL_DECLARATION_NDF_DEPENSE_ADD_JUSTIFICATIF_ENDPOINT,
     CONST_API_PERSONNEL_DECLARATION_NDF_DEPENSE_DELETE_ENDPOINT,
     CONST_API_PERSONNEL_DECLARATION_NDF_DEPENSE_EDIT_DEPENSE_GROUPED_ENDPOINT,
     CONST_API_PERSONNEL_DECLARATION_NDF_DEPENSE_EDIT_DEPENSE_SIMPLE_ENDPOINT,
     CONST_API_PERSONNEL_DECLARATION_NDF_DEPENSE_JUSTIFICATIF_DELETE_ENDPOINT,
     CONST_API_PERSONNEL_DECLARATION_NDF_DEPENSE_JUSTIFICATIF_REPLACE_ENDPOINT,
} from "../../../../../endpoints"
import { IPersonnelNdfDetailModel, IPersonnelNdfDocumentModel, IPersonnelNdfModel } from "@common-models/*"
import {
     ICreateConnectedUserNdfDepenseGroupedRequestModel,
     ICreateConnectedUserNdfDepenseSimpleRequestModel,
     IEditConnectedUserNdfDepenseGroupedRequestModel,
     IEditConnectedUserNdfDepenseSimpleRequestModel,
} from "../../../mes-activites/ndf/core/_models"
import { CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM } from "@common-constants/*"

export function deletePersonnelNdfRequest(id: number) {
     return axios.delete(CONST_API_PERSONNEL_DECLARATION_NDF_DELETE_ENDPOINT(id), {})
}

export function getPersonnelNdfByIdRequest(id: number) {
     return axios.get<IPersonnelNdfModel | null>(CONST_API_PERSONNEL_DECLARATION_GET_NDF_BY_ID_ENDPOINT(id))
}

export function getPersonnelNdfDepensesRequest(id: number) {
     return axios.get<IPersonnelNdfDetailModel[]>(CONST_API_PERSONNEL_DECLARATION_GET_NDF_DEPENSES_ENDPOINT(id))
}

export function createPersonnelNdfDepenseGroupedRequest(ndf_id: number, childs: ICreateConnectedUserNdfDepenseGroupedRequestModel[], fichiers: File[]) {
     const formData = new FormData()

     childs.forEach((item, index) => {
          // Correction de la typo : description (avec un s)
          if (item.numeroTicket) formData.append(`childs[${index}][numeroTicket]`, item.numeroTicket.toString())
          if (item.montantTTC) formData.append(`childs[${index}][montantTTC]`, item.montantTTC.toString())
          if (item.categorie) formData.append(`childs[${index}][categorie]`, item.categorie)
          if (item.adresseDepart) formData.append(`childs[${index}][adresseDepart]`, item.adresseDepart)
          if (item.adresseArrive) formData.append(`childs[${index}][adresseArrive]`, item.adresseArrive)
          if (item.distanceTotale) formData.append(`childs[${index}][distanceTotale]`, item.distanceTotale.toString())
          if (item.nbTrajets) formData.append(`childs[${index}][nbTrajets]`, item.nbTrajets.toString())
          if (item.isAllerRetour !== null && item.isAllerRetour !== undefined) formData.append(`childs[${index}][isAllerRetour]`, item.isAllerRetour ? "1" : "0")

          if (item.description) formData.append(`childs[${index}][description]`, item.description)

          if (item.date) formData.append(`childs[${index}][date]`, item.date)
          if (item.repasSeulOuEnGroupe) formData.append(`childs[${index}][repasSeulOuEnGroupe]`, item.repasSeulOuEnGroupe)
          if (item.invites) item.invites.forEach((invite, idxInvite) => formData.append(`childs[${index}][invites][${idxInvite}]`, invite))

          if (item.categorie === CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM) {
               if (item.moisAnneeKm) formData.append(`childs[${index}][moisAnneeKm]`, `${item.moisAnneeKm}-01`)
               // FIX INDEX ICI : On utilise idxJour pour ne pas écraser l'index du child
               if (item.joursKm) item.joursKm.forEach((jour, idxJour) => formData.append(`childs[${index}][joursKm][${idxJour}]`, jour.toString()))
          }
     })

     fichiers.forEach((file, index) => formData.append(`fichiers[${index}]`, file))

     return axios.post<IPersonnelNdfDetailModel>(CONST_API_PERSONNEL_DECLARATION_NDF_ADD_DEPENSE_GROUPED_ENDPOINT(ndf_id), formData)
}

export function createPersonnelNdfDepenseSimpleRequest(id: number, payload: ICreateConnectedUserNdfDepenseSimpleRequestModel) {
     const formData = new FormData()
     if (payload.date) formData.append(`data[date]`, payload.date)
     if (payload.categorie) formData.append(`data[categorie]`, payload.categorie)
     if (payload.adresseDepart) formData.append(`data[adresseDepart]`, payload.adresseDepart)
     if (payload.adresseArrive) formData.append(`data[adresseArrive]`, payload.adresseArrive)
     if (payload.nbTrajets) formData.append(`data[nbTrajets]`, payload.nbTrajets.toString())
     if (payload.isAllerRetour !== null && payload.isAllerRetour !== undefined) formData.append(`data[isAllerRetour]`, payload.isAllerRetour ? "1" : "0")
     if (payload.description) formData.append(`data[description]`, payload.description)
     if (payload.montantTTC) formData.append(`data[montantTTC]`, payload.montantTTC.toString())
     if (payload.distanceTotale) formData.append(`data[distanceTotale]`, payload.distanceTotale.toString())
     if (payload.documents) payload.documents.map((item, index) => formData.append(`documents[${index}]`, item))
     if (payload.repasSeulOuEnGroupe) formData.append(`data[repasSeulOuEnGroupe]`, payload.repasSeulOuEnGroupe)
     if (payload.invites) payload.invites.map((item, index) => formData.append(`data[invites][${index}]`, item))
     if (payload.categorie == CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM) {
          if (payload.moisAnneeKm) formData.append(`data[moisAnneeKm]`, `${payload.moisAnneeKm}-01`)
          if (payload.joursKm) payload.joursKm.map((item, index) => formData.append(`data[joursKm][${index}]`, item.toString()))
     }
     return axios.post<IPersonnelNdfDetailModel>(CONST_API_PERSONNEL_DECLARATION_NDF_ADD_DEPENSE_SIMPLE_ENDPOINT(id), formData)
}

export function deletePersonnelNdfDepenseRequest(id: number) {
     return axios.delete(CONST_API_PERSONNEL_DECLARATION_NDF_DEPENSE_DELETE_ENDPOINT(id))
}

export function editPersonnelDepenseGroupedRequest(id: number, payload: IEditConnectedUserNdfDepenseGroupedRequestModel) {
     const formattedPayload = {
          ...payload,
          depenses: payload.depenses.map(item => {
               const formattedItem: any = {
                    ...item,
                    // Conversion du ticket en string comme attendu par le DTO
                    numeroTicket: item.numeroTicket ? item.numeroTicket.toString() : undefined,
               }

               // Logique spécifique à l'indemnité KM
               if (item.categorie === CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM) {
                    if (item.moisAnneeKm) {
                         // Ajout de "-01" pour que Symfony puisse le transformer en objet DateTime
                         formattedItem.moisAnneeKm = `${item.moisAnneeKm}-01`
                    }
                    if (item.joursKm) {
                         // On s'assure que les jours sont envoyés en tant que tableau de strings
                         formattedItem.joursKm = item.joursKm.map(String)
                    }
               }

               return formattedItem
          }),
     }

     return axios.post<IPersonnelNdfDetailModel>(CONST_API_PERSONNEL_DECLARATION_NDF_DEPENSE_EDIT_DEPENSE_GROUPED_ENDPOINT(id), formattedPayload)
}

export function editPersonnelNdfDepenseSimpleRequest(id: number, payload: IEditConnectedUserNdfDepenseSimpleRequestModel) {
     if (payload.nbTrajets) payload.nbTrajets = Number(payload.nbTrajets)
     if (payload.categorie === CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM) {
          payload.moisAnneeKm = `${payload.moisAnneeKm}-01`
     }
     return axios.post<IPersonnelNdfDetailModel>(CONST_API_PERSONNEL_DECLARATION_NDF_DEPENSE_EDIT_DEPENSE_SIMPLE_ENDPOINT(id), payload)
}

export function addPersonnelNdfJustificatifRequest(ndf_detail_id: number, justificatif: File) {
     const formData = new FormData()
     formData.append("justificatif", justificatif)
     return axios.post<IPersonnelNdfDocumentModel>(CONST_API_PERSONNEL_DECLARATION_NDF_DEPENSE_ADD_JUSTIFICATIF_ENDPOINT(ndf_detail_id), formData)
}

export function deletePersonnelNdfJustificatifRequest(id: number) {
     return axios.delete(CONST_API_PERSONNEL_DECLARATION_NDF_DEPENSE_JUSTIFICATIF_DELETE_ENDPOINT(id))
}

export function replacePersonnelNdfJustificatifRequest(id: number, justificatif: File) {
     const formData = new FormData()
     formData.append("justificatif", justificatif)
     return axios.post<IPersonnelNdfDocumentModel>(CONST_API_PERSONNEL_DECLARATION_NDF_DEPENSE_JUSTIFICATIF_REPLACE_ENDPOINT(id), formData)
}
